import keyBy from 'lodash/keyBy';
import { HttpClient } from './http-client';

export const traceDetails = process.env.TRACE_DETAILS?.trim() ? keyBy(process.env.TRACE_DETAILS.split(',').map((f) => f.trim()).filter(Boolean)) : undefined;

const cache = {
	PUBLIC_CLIENT: {} as Record<string, HttpClient>,
	PRIVATE_CLIENT: {} as Record<string, HttpClient>,
};
export const getClient = (pub: boolean, baseUrl: string, traceDetails?: Record<string, string>) => {
	const root = pub ? 'PUBLIC_CLIENT' : 'PRIVATE_CLIENT';
	if (!cache[root][baseUrl]) {
		cache[root][baseUrl] = new HttpClient({ baseUrl, traceDetails, isPublic: !!pub });
	}
	return cache[root][baseUrl];
};
const mockURL = `http://localhost:${process.env.MOCK_HOST_PORT}`;
export const getBaseOrMockURL = (baseUrl: string) => `${process.env.USE_MOCK === 'true' ? mockURL : baseUrl}/model-results-api/`;

